import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { CreatorsAnchors } from '../../../../store/ducks/anchors'
import {
  formatRenderToDate,
} from '../../../../utils/functions';
import api from '../../../../services/api'
import { getPermissions } from '../../../../services/auth'
import { useHistory } from 'react-router'

import Render from './RegisterRender'

function Register ({ id }) {
  const history = useHistory()

  const dispatch = useDispatch()

  const [inputs, setInputs] = useState({})
  const [getErros, setErros] = useState([])
  const [getLoading, setLoading] = useState(true)

  const handleInputChange = (event, value) => {
    event.persist()
    setInputs(inputs => ({ ...inputs, [event.target.name]: value || event.target.value }))
  }

  const getInfoForForm = async () => {
    try {
      const findAncoraTaxaFaixa = await api.get(`AncorasTaxasFaixas/ConsultarId?id=${id}`)
      setInputs(findAncoraTaxaFaixa.data.resposta)
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message)
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.')
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    dispatch(CreatorsAnchors.changeLastGrid('ancoras-taxas-faixas'))
    const permissions = getPermissions({ moduloId: 1344, permissao: 'Alterar' })

    if (permissions) {
      getInfoForForm()
    } else {
      history.push('/app')
    }
  }, [])

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault()

      setLoading(true)
      try {
        const response = await api.put('AncorasTaxasFaixas', {
          ...inputs,
          dataRegistro: undefined,
          ancoraTaxaFaixaId: parseInt(id),
          valorInicial: inputs.valorInicial ? parseFloat(inputs.valorInicial) : 0,
          valorFinal: inputs.valorFinal ? parseFloat(inputs.valorFinal) : 0,
          taxa: inputs.taxa ? parseFloat(inputs.taxa) : 0,
          status: inputs.status ? inputs.status : 'Ativo',
          dataInicioCobranca: inputs.dataInicioCobranca ? formatRenderToDate(inputs.dataInicioCobranca) : '',
          dataFinalCobranca: inputs.dataFinalCobranca ? formatRenderToDate(inputs.dataFinalCobranca) : ''
        })
        if (response.data.status !== 'Inconsistencia') {
          setInputs({
            ...inputs,
            dataAtualizacao: response.data.resposta.dataAtualizacao
          })

          toast.success('Taxas faixas alterada com sucesso!')
        } else {
          if (response.data.resposta[0].key) {
            const errosArray = []

            response.data.resposta.map(resposta => {
              errosArray.push(resposta.key)

              toast.error(resposta.key + ' - ' + resposta.message)
              return null
            })

            setErros(errosArray)
          } else {
            toast.error('Não foi possível alterar a âncoras taxa faixas!')
          }
        }
      } catch (err) {
        console.log(err)
        if (err.response?.data && err.response?.data?.resposta[0]) {
          toast.error(err.response.data.resposta[0].message)
        } else {
          toast.error('Detectamos um problema interno! tente novamente em instantes.')
        }
      }
      setLoading(false)
    }
  }

  return <Render
    inputs={inputs}
    getLoading={getLoading}
    handleInputChange={handleInputChange}
    getErros={getErros}
    setErros={setErros}
    onSubmit={handleSubmit}
  />
}

export default Register
